import React, { useState } from "react";
import PropTypes from "prop-types";
import Text, {
  TEXT_ALIGN,
  TEXT_COLOR,
  TEXT_FONT_WEIGHT,
  TEXT_HEADING_LEVEL,
  TEXT_KIND,
  TEXT_SEGMENT,
  TEXT_SIZE,
} from "@/bit/components/components.text";
import CustomLink from "@/bit/components/components.custom-link";

export const COMPONENT_NAME = "ExpandableList";
export { TEXT_COLOR, TEXT_SEGMENT };

const ExpandableList = ({
  defaultExpanded = false,
  itemsList,
  segment,
  className,
}) => {
  const [showAll, setShowAll] = useState(defaultExpanded);

  const toggleShowAll = () => {
    setShowAll(value => !value);
  }

  const taggingInfo = {
    componentName: COMPONENT_NAME,
    componentContent: "",
    componentProduct: "",
    componentVariation: "none",
    eventType: "click",
  };

  return (
    <>
      {Array.isArray(itemsList) && itemsList.length > 0 && (
        <section className={`expandable-list ${className}`}>
          <div className={`list-items ${showAll ? '' : 'collapse'}`}>
            {itemsList.map((item, index) => (
              <div
                key={index}
                className={`list-item`}
              >
                <Text
                  text={item.title}
                  kind={TEXT_KIND.HEADING}
                  level={TEXT_HEADING_LEVEL.H2}
                  align={TEXT_ALIGN.LEFT}
                  size={TEXT_SIZE.T6}
                  fontType={TEXT_FONT_WEIGHT.BOLD}
                  segment={segment}
                  className="item-title"
                />
                <div
                  className={`item-description ${showAll ? 'show-all' : ''}`}
                >
                  <Text
                    size={TEXT_SIZE.BODY1}
                    segment={segment}
                    className="text-content"
                    text={item.description}
                  />
                </div>
              </div>
            ))}
          </div>

          <CustomLink
            title={showAll ? "Ver menos" : "Ver más"}
            ariaLabel={showAll ? "Ver menos" : "Ver más"}
            taggingInfo={{
              ...taggingInfo,
              componentProduct: `listItems`,
              componentContent: showAll
                ? "list-plegar"
                : "list-desplegar",
              componentVariation: "none",
              eventType: "click",
            }}
            onClick={toggleShowAll}
          >
            <Text
              text={showAll ? "Ver menos" : "Ver más"}
              kind={TEXT_KIND.HEADING}
              level={TEXT_HEADING_LEVEL.H3}
              align={TEXT_ALIGN.LEFT}
              color={TEXT_COLOR.BLUE}
              size={TEXT_SIZE.SUBTITLE2}
              fontType={TEXT_FONT_WEIGHT.REGULAR}
              segment={segment}
              className="text-content"
            />
          </CustomLink>
        </section >
      )}
      <style jsx>{`.expandable-list {
  :global(a) {
    color: #0079bb;

    &:hover {
      opacity: 0.8;
    }
  }
  .list-item {
    &--with-borders {
      border: 1px solid #eeeeee;
    }

    &--with-bottom-border {
      border-bottom: 1px solid #eeeeee;

      &:hover {
        background-color: #f5f5f5;
      }
    }
  }

  .list-items.collapse {
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 4;
    @media (max-width: 480px) {
      -webkit-line-clamp: 10;
    }
    overflow: hidden;
    margin-bottom: 1rem;
  }

  .item-description {
    :global(span p) {
      margin-bottom: 0.5rem;
    }
    @media (max-width: 480px) {
      :global(span p:nth-last-child(1)) {
        margin-bottom: 1rem;
      }
    }
  }

  :global(.item-title) {
    margin-bottom: 0.5rem;
  }
}`}</style>
    </>
  );
};

ExpandableList.propTypes = {
  /**
   * Booleano que nos permite visualizar expandido por defecto el contenido
   */
  defaultExpanded: PropTypes.bool,
  /**
   * Listado de preguntas frecuentes/faqs
   */
  itemsList: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string.isRequired,
      description: PropTypes.string.isRequired,
    }).isRequired
  ).isRequired,
  /**
   *  Necesita para especificar el segmento
   */
  segment: PropTypes.string,
  className: PropTypes.string,
};

ExpandableList.defaultProps = {
  defaultExpanded: false,
  segment: TEXT_SEGMENT.GP,
  className: "",
};

export default ExpandableList;